import { useMemo } from "react";
import { useFirestoreCollectionReadWrite } from "./useFirestoreCollectionReadWrite";
import { Tpa as TPA } from "@rebuild/shared/models";

export const useTpas = () => {
	const { objects: tpaObjects, isLoading } = useFirestoreCollectionReadWrite<TPA>("tpa_objects");
	const tpas = useMemo(() => tpaObjects.filter((tpa) => !tpa.disabled), [tpaObjects]);

	return { tpas, isLoading };
};
